import { Action } from '@ngrx/store';


export enum CatalogoActionTypes {
  CATALOGO_INICIAL = '[CATALOGO] Inicial',
  CATALOGO_GET = '[CATALOGO] Get',
  CATALOGO_SUCCESS = '[CATALOGO] Success',
  CATALOGO_FAIL = '[CATALOGO] Fail'
}

export class CatalogoInicial implements Action {
  readonly type = CatalogoActionTypes.CATALOGO_INICIAL;
  constructor() {}
}

export class CatalogoGet implements Action {
  readonly type = CatalogoActionTypes.CATALOGO_GET;
  constructor(public tipo: string ) {}
}

export class CatalogoSuccess implements Action {
    readonly type = CatalogoActionTypes.CATALOGO_SUCCESS;
    constructor(public Items: any[]) {}
}


export class CatalogoFail implements Action {
    readonly type = CatalogoActionTypes.CATALOGO_FAIL;
    constructor(public error: any) {}
}

export type CatalogoAcciones =
    | CatalogoInicial
    | CatalogoGet
    | CatalogoSuccess
    | CatalogoFail;
